var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TemplateTable',{attrs:{"title":_vm.$t('menu.photos'),"text":_vm.$t('resalesPhotos.description'),"name":"resalesPhotos","url":_vm.$listRoutes.resalesPhotos,"table":_vm.resalesPhotos,"filters":_vm.resalesPhotosFilters,"fields":_vm.fields}})
}
var staticRenderFns = []

export { render, staticRenderFns }